module.exports = __webpack_public_path__ + "img/ILCE7M3.760167e1.jpg";